'use client';

import { dequal as deepEqual } from 'dequal/lite';
import { useRef } from 'react';

/**
 * @description incrementing signal if deep equality with the last render object fails
 */
export const useDeepCompareMemoize = (value: unknown): number[] => {
  const ref = useRef<unknown>();
  const signalRef = useRef<number>( 0 );

  if (!deepEqual( value, ref.current )) {
    ref.current = value;
    signalRef.current += 1;
  }

  return [signalRef.current];
};
